import autoBind from 'auto-bind'

export interface LoadersType {
  [key: string]: { load: (...args) => any }
}

export class BaseType {
  public static applyMiddlewareForLoader(handlers = [], loader, postHandlers = []): any | never {
    if (!handlers) {
      return loader
    }
    return async args => {
      try {
        for (const handler of handlers) {
          await handler(
            args[0][1],
            args[0][2],
            args[0][3],
            args.map(([id]) => id)
          )
        }
        const result = await loader(args.map(([id]) => id))
        if (postHandlers) {
          for (const handler of postHandlers) {
            await handler(result, ...args[0])
          }
        }
        return result
      } catch (e) {
        throw e
      }
    }
  }
  protected static $loaders: LoadersType

  constructor() {
    autoBind(this)
  }

  public applyMiddlewares(
    handlers = [],
    loaders: { [key: string]: (...args) => any } = {},
    postHandlers = []
  ): {
    [key: string]: any
  } {
    // return if there is no middlewares
    if (!handlers) {
      return loaders
    }

    // iterate over loaders
    for (const [name, loader] of Object.entries(loaders)) {
      // wrap the loader function
      loaders[name] = async (...args) => {
        try {
          // execute handlers
          for (const handler of handlers) {
            await handler(...args)
          }
          // call loader function
          const result = await loader(args[0])

          // post handlers
          if (postHandlers) {
            for (const handler of postHandlers) {
              await handler(result, ...args)
            }
          }
          // return the result
          return result
        } catch (e) {
          throw e
        }
      }
    }
    return loaders
  }
}
